<template>
    <div class="page--circle">

        <div class="container">
            <h1 class="page__title">{{ $t("add-a-person-per-day") }}</h1>


            <h2>{{ $t("select-a-circle-to-add-a-profil") }}</h2>

            <div class="page--circle__form">
                <div class="grid">
                    <div class="grid__item desktop--5">
                        <div class="grid">
                            <div class="grid__item desktop--10">
                                <label class="field__label">{{ $t("circles") }}</label>
                                <field-select
                                    name="add-circles"
                                    id="field-add-circle"
                                    input-label-id="field-add-circle-label"
                                    @update-value="updateAddCircle"
                                    :options="circlesAddOptions" />
                            </div>
                        </div>

                        <template v-if="currentAddGroup">
                            <template v-if="currentAddGroup.id_group_type === '5' || currentAddGroup.id_group_type === 'default-5'">
                                <new-star-form
                                    ref="newStarForm"
                                    @add-star="addStar" />
                            </template>
                            <template v-else>
                                <new-user-form
                                    ref="newUserForm"
                                    @add-user="addUser" />
                            </template>
                        </template>
                    </div>
                    <div
                        v-if="groups && groups.length > 0"
                        class="grid__item desktop--push--2 desktop--5">
                        <label class="field__label">{{ $t("circles") }}</label>
                        <field-select
                            name="view-circles"
                            id="field-view-circle"
                            input-label-id="field-view-circle-label"
                            @update-value="updateViewCircle"
                            :options="circlesViewOptions" />

                        <ul class="members-list">
                            <li
                                v-for="(member, index) in currentViewGroupMembers"
                                :key="`member-${index}`"
                                class="members-list__item">
                                <div class="members-list__item-detail">
                                    <span class="member__name">
                                        {{ member.name.toLowerCase() }}
                                    </span>
                                </div>
                                <button
                                    @click.prevent="removeMember(member)"
                                    type="button"
                                    class="button button--circle">
                                    <img
                                        class="button__icon"
                                        src="@/assets/images/icons/icon-small-cross.svg"
                                        alt="" />
                                    <span class="sr-only">{{ $t("remove") }}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
//
import FieldSelect from "@/components/forms/FieldSelect.vue";
import NewUserForm from "@/components/circles/NewUserForm.vue";
import NewStarForm from "@/components/circles/NewStarForm.vue";

import { getGroupTypeName } from "@/utils/helpers/group.js";

import { register, getUserInfo, getmeFirsTime , getCompare, getMeTimelineFirstTime, getMeCycleFirstTime} from "@/utils/api/usersApi.js";
import { userGroupInfo, userGroupCreate, userGroupAdd, userGroupRemove } from "@/utils/api/groupsApi.js";

import { GROUPS } from "@/utils/constants/groups.js";
import { capitalize } from "@/utils/helpers/string.js";

export default {
    name: "Circles",
    components: {
        FieldSelect: FieldSelect,
        NewUserForm: NewUserForm,
        NewStarForm: NewStarForm
    },
    data () {
        return {
            currentAddCircle: "1",
            currentViewCircle: "1",
            defaultCircleType: ["default-1", "default-2", "default-3", "default-4", "default-5", "default-6"],
        };
    },
    computed: {
        // loggedUser
        // Current logged user
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        // groups
        // User groups info
        groups() {
            return this.$store.getters["userModule/getGroups"];
        },
        // circles Add options
        circlesAddOptions() {

            // Generic circles
            let circles = GROUPS.map((item) => {
                return {
                    "value": `default-${item.id_group_type}`,
                    "label": this.$t(item.group_type_name)
                };
            });

            if (this.groups) {
                // Overwrite generic circle by real one if some exists
                this.groups.map((group) => {
                    const index = this.getObjetIndexByKey(circles, "value", `default-${group.id_group_type}`);

                    if (index > -1) {
                        circles[index] = {
                            "value": group.id_group,
                            "label": this.$t(getGroupTypeName(group.id_group_type))
                        };
                    }
                });
            }

            return circles;
        },
        currentAddGroup() {
            if(this.currentAddCircle) {
                if (this.groups) {
                    let idType = this.currentAddCircle;

                    const index = this.getObjetIndexByKey(this.groups, "id_group", idType);

                    if (index > -1) {
                        return this.groups[index];
                    }
                }

                return {
                    "id_group_type": this.currentAddCircle
                };
            }
        },
        // circles View options
        circlesViewOptions() {
            // Generic circles
            let circles = [];

            if (this.groups) {
                this.groups.map((group) => {
                    const option = {
                        "value": group.id_group,
                        "label": this.$t(getGroupTypeName(group.id_group_type))
                    };

                    circles.push(option);
                });
            }

            return circles;
        },
        currentViewGroup() {
            let group = [];

            if (this.groups) {
                const index = this.getObjetIndexByKey(this.groups, "id_group", this.currentViewCircle);

                if (index > -1) {
                    group = this.groups[index];
                }
            }

            return group;
        },
        currentViewGroupMembers() {
            let members = [];

            if (this.currentViewGroup && this.currentViewGroup.id_person_2) {

                const membersIdArray = this.currentViewGroup.id_person_2.split(",");
                const membersNameArray = this.currentViewGroup.name.split(",");

                for (var i = membersIdArray.length - 1; i >= 0; i--) {

                    const member = {
                        id: membersIdArray[i],
                        name: membersNameArray[i]
                    };

                    members.push(member);
                }
            }

            const sorteArray = members.sort(function(a, b) {
                var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                var nameB = b.name.toUpperCase(); // ignore upper and lowercase

                if (nameA < nameB) {
                    return -1; //nameA comes first
                }

                if (nameA > nameB) {
                    return 1; // nameB comes first
                }

                return 0;  // names must be equal
            });

            return sorteArray;
        }
    },
    mounted() {
        // User Groups
        if (!this.groups) {
            this.fetchGroups();
        }
    },
    methods: {
        updateAddCircle(value) {
            this.currentAddCircle = value;
        },
        updateViewCircle(value) {
            this.currentViewCircle = value;
        },
        addUser(memberToAdd) {
            // Create a new Friends (User whitout mail/pwd)
            register(memberToAdd).then((res) => {
                if (res.data.status === "ok") {
                    if (res.data.id_person) {

                        const newUserId = res.data.id_person;

                        this.$refs.newUserForm.resetForm();

                        getMeCycleFirstTime(res.data.id_person);

                        // This group allready exists
                        // Add user to it
                        if (this.groups && this.defaultCircleType.indexOf(this.currentAddCircle) === -1) {
                            const group = {
                                "id": this.currentAddCircle,
                                "ownerId": this.loggedUser.id_person,
                            };

                            const member = {
                                "id": res.data.id_person,
                                "name": memberToAdd.pseudo
                            };

                            userGroupAdd(group, member).then((res) => {
                                if (res.data.status === "ok" && res.data.id_group) {
                                    this.$store.commit("userModule/setComparison", null);
                                    this.fetchGroups();
                                    this.initUserInsight(newUserId);
                                    // getCompare(newUserId);
                                    this.$notificationsBar.alert(`${member.name} ${this.$t("was-successfully-added-to-group")}`, {type: "success"});
                                }
                            });

                        } else {
                            // This group doesn't exists, create a new one
                            // Create new group
                            const group = {
                                "type": this.currentAddCircle.substring(8), // Remove the 8 first char (default-)
                                "ownerId": this.loggedUser.id_person
                            };

                            const member = {
                                "id": res.data.id_person,
                                "name": memberToAdd.pseudo
                            };

                            userGroupCreate(group, member).then((res) => {
                                if (res.data.status === "ok" && res.data.id_group) {
                                    this.$store.commit("userModule/setComparison", null);
                                    this.fetchGroups();
                                    this.initUserInsight(newUserId);
                                    // getCompare(newUserId);
                                    this.$notificationsBar.alert(`${member.name} ${this.$t("was-successfully-added-to-group")}`, {type: "success"});
                                }
                            });
                        }

                    }
                } else {
                    // Handle Error
                    this.$notificationsBar.alert(res.data.message, {type: "warning"});
                    throw (res);
                }
            });
        },
        addStar(star) {
            // This group allready exists
            // Add user to it
            if (this.groups && this.defaultCircleType.indexOf(this.currentAddCircle) === -1) {
                const group = {
                    "id": this.currentAddCircle,
                    "ownerId": this.loggedUser.id_person,
                };

                const member = {
                    "id": star.id_person,
                    "name": star.name
                };

                userGroupAdd(group, member).then((res) => {
                    if (res.data.status === "ok" && res.data.id_group) {
                        this.$store.commit("userModule/setComparison", null);
                        // Reset Previously saved in store insightTraits
                        this.$store.commit("userModule/setInsightTraits", null);
                        this.fetchGroups();
                        // this.initUserInsight(newUserId);
                        // getCompare(newUserId);
                        this.$notificationsBar.alert(`${member.name} ${this.$t("was-successfully-added-to-group")}`, {type: "success"});
                    }
                });

            } else {
                // This group doesn't exists, create a new one
                // Create new group
                const group = {
                    "type": this.currentAddCircle.substring(8), // Remove the 8 first char (default-)
                    "ownerId": this.loggedUser.id_person
                };

                const member = {
                    "id": star.id_person,
                    "name": star.name
                };

                userGroupCreate(group, member).then((res) => {
                    if (res.data.status === "ok" && res.data.id_group) {
                        this.$store.commit("userModule/setComparison", null);
                        // Reset Previously saved in store insightTraits
                        this.$store.commit("userModule/setInsightTraits", null);
                        this.fetchGroups();
                        // this.initUserInsight(newUserId);
                        // getCompare(newUserId);
                        this.$notificationsBar.alert(`${member.name} ${this.$t("was-successfully-added-to-group")}`, {type: "success"});
                    }
                });
            }
        },
        removeMember(member) {
            const group = {
                "id": this.currentViewCircle,
                "ownerId": this.loggedUser.id_person,
            };

            userGroupRemove(group, member).then((res) => {
                if (res.data.status === "ok") {
                    this.fetchGroups();
                    this.initUserInsight();
                    this.$notificationsBar.alert(`${member.name} ${this.$t("was-successfully-removed")}`, {type: "success"});
                } else {
                    // Handle Error
                    this.$notificationsBar.alert(res.data.message, {type: "warning"});
                    throw (res);
                }
            });
        },
        initUserInsight(userId) {
            // Reset Previously saved in store insightTraits
            this.$store.commit("userModule/setInsightTraits", null);
            // Init (or reinit) userInsight (it's a silent call to the api, no need to wait an answer)
            getmeFirsTime(userId).then((res) => {
                getMeTimelineFirstTime(userId);
            });
        },
        // Fetch User Groups Info
        fetchGroups() {
            const user = {
                "id": this.loggedUser.id_person
            };

            userGroupInfo(user).then((res) => {
                if (res.status === 200 && res.data) {
                    if (res.data.message === "no group for user") {
                        this.$store.commit("userModule/setGroups", null);
                        return;
                    } else {
                        this.$store.commit("userModule/setGroups", res.data);
                    }
                }
            });
        }
    }
};
</script>

